"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabList = void 0;
var tslib_1 = require("tslib");
var tabs_1 = require("@reach/tabs");
var react_1 = tslib_1.__importStar(require("react"));
var react_use_1 = require("react-use");
var slider_1 = require("../styled/slider");
var tab_list_1 = require("../styled/tab-list");
var tabs_2 = require("../tabs");
var TabList = function (_a) {
    var children = _a.children, showScrollButtons = _a.showScrollButtons;
    var selectedIndex = (0, tabs_1.useTabsContext)().selectedIndex;
    var _b = (0, react_1.useContext)(tabs_2.TabsContext), pattern = _b.pattern, isInverse = _b.isInverse;
    var windowWidth = (0, react_use_1.useWindowSize)().width;
    var count = react_1.Children.toArray(children).filter(function (c) { return !!c; }).length;
    var _c = (0, react_1.useState)(null), tabsRef = _c[0], setTabsRef = _c[1];
    var _d = (0, react_1.useState)(null), tabsRootRef = _d[0], setTabsRootRef = _d[1];
    var tabsRefSetter = (0, react_1.useCallback)(function (node) {
        if (node !== null) {
            setTabsRef({ current: node });
        }
    }, []);
    var tabsRootRefSetter = (0, react_1.useCallback)(function (node) {
        if (node !== null) {
            setTabsRootRef({ current: node });
        }
    }, []);
    var indexedChildren = react_1.Children.map(children, function (child, index) {
        return (0, react_1.isValidElement)(child) ? (0, react_1.cloneElement)(child, { index: index, tabsRef: tabsRef }) : child;
    });
    var scrollTabs = function (direction) {
        if (tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) {
            var containerWidth = tabsRef.current.clientWidth;
            tabsRef.current.scrollBy({
                left: Number(containerWidth / 2) * (direction === 'left' ? -1 : 1),
                top: 0,
                behavior: 'smooth',
            });
        }
    };
    var _e = (0, react_1.useState)(0), scrollOverflow = _e[0], setScrollOverflow = _e[1];
    var _f = (0, react_1.useState)(false), showLeftScrollButton = _f[0], setShowLeftScrollButton = _f[1];
    var _g = (0, react_1.useState)(false), showRightScrollButton = _g[0], setShowRightScrollButton = _g[1];
    var buttonShowBuffer = 20;
    var toggleScrollButtons = (0, react_1.useCallback)(function (scrollOverflow) {
        if (tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) {
            setShowLeftScrollButton(tabsRef.current.scrollLeft > buttonShowBuffer);
            setShowRightScrollButton(tabsRef.current.scrollLeft + buttonShowBuffer < scrollOverflow);
        }
    }, [tabsRef]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var scrollOverflow = (((_a = tabsRootRef === null || tabsRootRef === void 0 ? void 0 : tabsRootRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) -
            (((_b = tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0);
        setScrollOverflow(scrollOverflow);
        toggleScrollButtons(scrollOverflow);
    }, [tabsRef, tabsRootRef, windowWidth, toggleScrollButtons]);
    return (react_1.default.createElement(tab_list_1.TabListWrapper, { ref: tabsRefSetter, onScroll: function () { return toggleScrollButtons(scrollOverflow); } },
        showScrollButtons && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(tab_list_1.ButtonAnchor, { position: "left" },
                react_1.default.createElement(tab_list_1.TabOverflowButton, { hide: !showLeftScrollButton, position: "left", title: "scrollLeft", "data-testid": "tabs-arrow-back", onClick: function () { return scrollTabs('left'); }, icon: "arrow-back", isOutlined: true })),
            react_1.default.createElement(tab_list_1.ButtonAnchor, { position: "right" },
                react_1.default.createElement(tab_list_1.TabOverflowButton, { hide: !showRightScrollButton, position: "right", title: "scrollRight", "data-testid": "tabs-arrow-forward", onClick: function () { return scrollTabs('right'); }, icon: "arrow-forward", isOutlined: true })))),
        react_1.default.createElement(tab_list_1.TabListRoot, { pattern: pattern, count: count, ref: tabsRootRefSetter },
            indexedChildren,
            pattern !== 'nested' && (react_1.default.createElement(slider_1.Slider, { pattern: pattern, count: count, selectedIndex: selectedIndex, isInverse: isInverse })))));
};
exports.TabList = TabList;
//# sourceMappingURL=tab-list.js.map